import { useEffect, useState } from "react";
import { FormRoleFieldSettingsItemDto, GetFormRoleFieldSettingsResponseDto } from "../../types";
import useDataFetcher from "../../../../knisot/hooks/useFetchData";
import { UI_FORMS } from "../../../../../../../modules/API/UIForms/uiform";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../../../store/reducers/rootReducer";
import { IUser } from "../../../../../../../modules/API/Auth/models/authDataModel";
import { handleNotifications } from "../../../../../../../generic/utils/handleNotifications";
import { PRODUCT_CREATION_FORM_ID } from "../../constants/formlist";

export const useProductCreationFieldsControl = () => {
    const user = useSelector((state: RootState) => state.mainReducer.user) as IUser;
    const roles = user.rights;

    const [productCreationFields, setProductCreationFields] = useState<GetFormRoleFieldSettingsResponseDto | null>(null);
    const [productCreationFieldsDict, setProductCreationFieldsDict] = useState<Record<string, FormRoleFieldSettingsItemDto>>({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchProductCreationFields = async () => {
            setIsLoading(true);
            try {
                const response = await UI_FORMS.getFieldSettings(PRODUCT_CREATION_FORM_ID, roles);
                setProductCreationFields(response);
                setProductCreationFieldsDict(response.fields.reduce((acc, field) => {
                    acc[field.fieldSystemKey] = field;
                    return acc;
                }, {} as Record<string, FormRoleFieldSettingsItemDto>));
            } catch (error) {
                console.error(error);
                handleNotifications('שגיאה בטעינת הגדרות שדות', { type: 'error' });
            } finally {
                setIsLoading(false);
            }
        }
        fetchProductCreationFields();
    }, [roles]);

    return {
        productCreationFields,
        productCreationFieldsDict,
        isLoading,
    }
}